import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/turath2/turath-websites/turath-website-learn/en-dev/node_modules/next/dist/client/app-dir/link.js");
